import { setLanguage } from "./themes";

export const getBaseURL = () => {
  return process.env.REACT_APP_AUTH_APP_BASE_URL;
};

export const getBaseMultiURL = () => {
  let lan = getLanguage();
  if (lan === "en") {
    return "https://en-api.hopeofanewera.org/api/v1";
  } else {
    return "https://api.hopeofanewera.org/api/v1";
  }
};

export const getBaseInsightURL = () => {
  return process.env.REACT_APP_AUTH_APP_INSIGHT_URL;
};
export const getWarehouseURL = () => {
  return process.env.REACT_APP_AUTH_APP_WAREHOUSE_URL;
};
export const getLanguage = () => {
  const domain = window.location.hostname;

  let currentLang;

  // Check domain and assign language
  if (domain.includes("sinhala.hopeofanewera.org")) {
    currentLang = "si"; // Sinhala
  } else if (domain.includes("hopeofanewera.org")) {
    currentLang = "en"; // English
  } else {
    // fallback to saved language or .env
    currentLang =
      localStorage.getItem("app_language") ||
      process.env.REACT_APP_AUTH_APP_LANGUAGE ||
      "si"; // default English
  }

  // const currentLang =
  //   localStorage.getItem("app_language") ||
  //   process.env.REACT_APP_AUTH_APP_LANGUAGE;
  localStorage.setItem("app_language", currentLang);
  setLanguage(currentLang);

  return currentLang;
};

export const toggleLanguage = () => {
  const currentLang = getLanguage();
  const newLang = currentLang === "si" ? "en" : "si";

  localStorage.setItem("app_language", newLang);
  setLanguage(newLang);
  window.location.reload();
};
